<template>
  <khrc-navbar/>
  <hello-world />
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import KhrcNavbar from "@/components/KhrcNavbar.vue";
export default {
  name: "HomeView",
  components: {
    HelloWorld,
    KhrcNavbar,
  },
  mounted() {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  },
};
</script>
